import React from 'react';
import ordinal from "ordinal"

function hijriToString(day, month, year) {
    var months = new Array("Muharram", "Safar", "Rabi-al Awwal", "Rabi-al Thani", "Jumada al-Ula", "Jumada al-Thani", "Rajab", "Sha\'ban", "Ramadhan", "Shawwal", "Dhul Qa\'dah", "Dhul Hijjah");
    return ordinal(day) + " " + months[month - 1];
}

function normalizeHijriDate(day, month, year) {
    if (day === undefined || month === undefined || year === undefined) {
        return null;
    }

    let normalizedDay = day;
    let normalizedMonth = month;
    let normalizedYear = year;

    while (normalizedDay > 30) {
        normalizedDay -= 30;
        normalizedMonth += 1;
    }

    while (normalizedDay < 1) {
        normalizedDay += 30;
        normalizedMonth -= 1;
    }

    while (normalizedMonth > 12) {
        normalizedMonth -= 12;
        normalizedYear += 1;
    }

    while (normalizedMonth < 1) {
        normalizedMonth += 12;
        normalizedYear -= 1;
    }

    return {
        day: normalizedDay,
        month: normalizedMonth,
        year: normalizedYear,
    };
}

const HijriDate = ({dayplus, day, month, year, offset = 0}) => {

    if (day === undefined) return null;

    const adjustedDate = normalizeHijriDate(day + (dayplus ? 1 : 0) + offset, month, year);

    if (!adjustedDate) return null;

    return (
        <div>
            {(dayplus ? '*' : '') + hijriToString(adjustedDate.day, adjustedDate.month, adjustedDate.year)}
            <div style={{fontSize: '40%', color: 'pink'}}>*Islamic date changes at magrib time</div>
        </div>
    );

};

export default HijriDate;
